import L from 'leaflet';
import defaultMarker from '../assets/img/markers/default.svg';
import accommodationMarker from '../assets/img/markers/accommodation.svg';
import restaurantMarker from '../assets/img/markers/restaurant.svg';
import wineryMarker from '../assets/img/markers/wine_cellar_or_cava.svg';
import wineShopMarker from '../assets/img/markers/wine_shop.svg';
import touristServiceMarker from '../assets/img/markers/tourist-service.svg';
import attractionMarker from '../assets/img/markers/attraction.svg';
import spaceMarker from '../assets/img/markers/space.svg';
import townMarker from '../assets/img/markers/town.svg';
import touristOfficeMarker from '../assets/img/markers/tourist-office.svg';
import natureMarker from '../assets/img/markers/nature.svg';
import secretMarker from '../assets/img/markers/secret.svg';

const defaultIcon = new L.Icon({
    iconUrl: defaultMarker,
    iconRetinaUrl: defaultMarker,
    iconSize: new L.Point(32, 50),
    className: 'leaflet-div-icon'
});

const accommodationIcon = new L.Icon({
    iconUrl: accommodationMarker,
    iconRetinaUrl: accommodationMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const restaurantIcon = new L.Icon({
    iconUrl: restaurantMarker,
    iconRetinaUrl: restaurantMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const wineryIcon = new L.Icon({
    iconUrl: wineryMarker,
    iconRetinaUrl: wineryMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const wineShopIcon = new L.Icon({
    iconUrl: wineShopMarker,
    iconRetinaUrl: wineShopMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const touristServiceIcon = new L.Icon({
    iconUrl: touristServiceMarker,
    iconRetinaUrl: touristServiceMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const attractionIcon = new L.Icon({
    iconUrl: attractionMarker,
    iconRetinaUrl: attractionMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const spaceIcon = new L.Icon({
    iconUrl: spaceMarker,
    iconRetinaUrl: spaceMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const townIcon = new L.Icon({
    iconUrl: townMarker,
    iconRetinaUrl: townMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const touristOfficeIcon = new L.Icon({
    iconUrl: touristOfficeMarker,
    iconRetinaUrl: touristOfficeMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const natureIcon = new L.Icon({
    iconUrl: natureMarker,
    iconRetinaUrl: natureMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

const secretIcon = new L.Icon({
    iconUrl: secretMarker,
    iconRetinaUrl: secretMarker,
    iconSize: new L.Point(50, 50),
    className: 'leaflet-div-icon'
});

export { defaultIcon, accommodationIcon, restaurantIcon, wineryIcon, wineShopIcon, touristServiceIcon, attractionIcon, spaceIcon, townIcon, touristOfficeIcon, natureIcon, secretIcon };